import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EventOverviewComponent } from './containers/event-overview/event-overview.component';
import { EventDetailGuard, EventDetailNoDateGuard, EventOverviewGuard, FeaturedEventsGuard, FilterFieldsGuard } from './guards';
import { provideState } from '@ngrx/store';

import * as fromStore from './store';
import { provideEffects } from '@ngrx/effects';
import { EventDetailComponent } from './containers/event-detail/event-detail.component';
import { EventDetailMetaGuard } from './guards/event-detail-meta.guard';
import { menuThemeGuard, resetMenuThemeGuard } from '../guards/menu-theme.guard';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: EventOverviewComponent,
        canActivate: [EventOverviewGuard, FeaturedEventsGuard, FilterFieldsGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
      },
      {
        path: ':eventId/:target',
        component: EventDetailComponent,
        canActivate: [EventDetailNoDateGuard, EventDetailMetaGuard, menuThemeGuard],
        data: {
          navTheme: 'accent',
          reuseComponent: false,
        },
      },
      {
        path: ':eventId/:eventDate/:target',
        component: EventDetailComponent,
        canActivate: [EventDetailGuard, EventDetailMetaGuard, menuThemeGuard],
        data: {
          navTheme: 'accent',
          reuseComponent: false,
        },
      },
    ],
    data: {
      navTheme: 'secondary',
      reuseComponent: true,
    },
    canActivate: [menuThemeGuard],
    //canDeactivate: [resetMenuThemeGuard],
    providers: [
      provideState(fromStore.featureKey, fromStore.reducers, {
        metaReducers: fromStore.metaReducers,
      }),
      provideEffects(fromStore.effects),
    ],
  },
];
